import { Box, Container } from '@mui/material';
import { OnboardingForm } from '@nohara-dxdev/react-oidc';

import { paths } from '@/config/paths';

const OnboardingRoute = () => {
  return (
    <Container maxWidth='sm' sx={{ py: 8 }}>
      <Box sx={{ my: 4 }}>
        <OnboardingForm homePath={paths.home.getHref()} />
      </Box>
    </Container>
  );
};

export default OnboardingRoute;
